import { z } from 'zod';

/** Six digits, one optional space in the middle, as authenticator apps display them. */
export const TOTP_CODE = /^\d{3}\s?\d{3}$/;
/** Recovery codes look like `ab2c-d3ef`; the hyphen may be left out when typing. */
export const RECOVERY_CODE = /^[a-z0-9]{4}-?[a-z0-9]{4}$/i;
const SLUG = /^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;

const totpCode = z.string().trim().regex(TOTP_CODE, { error: 'auth:validation.totpCode' });
const recoveryCode = z
  .string()
  .trim()
  .regex(RECOVERY_CODE, { error: 'auth:validation.recoveryCode' });

export const authenticatorCodeSchema = z.object({ code: totpCode });
export const recoveryCodeSchema = z.object({ code: recoveryCode });
export type CodeValues = z.infer<typeof authenticatorCodeSchema>;

export const disableTwoFactorSchema = z.object({
  password: z.string().min(1, { error: 'auth:validation.required' }),
  code: totpCode,
});
export type DisableTwoFactorValues = z.infer<typeof disableTwoFactorSchema>;

export const magicLinkRequestSchema = z.object({
  email: z.email({ error: 'auth:validation.email' }),
  organizationSlug: z
    .string()
    .trim()
    .max(120, { error: 'auth:validation.organizationSlug' })
    .refine((value) => value === '' || SLUG.test(value), {
      error: 'auth:validation.organizationSlug',
    }),
});
export type MagicLinkRequestValues = z.infer<typeof magicLinkRequestSchema>;
